import {ReduxStateType} from '../store';

export const selectDeductionsChangelog = (state: ReduxStateType) =>
  state.deductionsChangelog;
